import { render, staticRenderFns } from "./no-data-placeholder.vue?vue&type=template&id=8ba79436"
import script from "./no-data-placeholder.vue?vue&type=script&lang=js"
export * from "./no-data-placeholder.vue?vue&type=script&lang=js"
import style0 from "./no-data-placeholder.vue?vue&type=style&index=0&id=8ba79436&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports